import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { CustomerAccountTypes } from '../../../shared/models/customer-account-types';
import { OnboardingService } from '../../../shared/onboarding.service';
import { Account } from '../../../shared/models';
import { Features } from '../../../shared/models/features.enum';

@Component({
  selector: 'app-website-admin-access',
  templateUrl: './website-admin-access.component.html',
  styleUrl: './website-admin-access.component.scss'
})
export class WebsiteAdminAccessComponent {
  loading = false;
  customerAccountTypes = CustomerAccountTypes;
  @Input() account: Account;
  selectedOption: 'crmInvite' | 'credentials' | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private onboardingService: OnboardingService
  ) { }

  selectGoogleLogin() {
    this.selectedOption = 'crmInvite';
  }

  selectCredentials() {
    this.selectedOption = 'credentials';
  }

  goBack() {
    this.selectedOption = null;
  }

  credentialsProvided() {
    let action: Observable<any> = of(null);

    // starter seo has a workflow dependent on credentials, notifiy workflow to proceed
    if (this.account.hasFeature(Features.StarterSEO)) {
      action = this.onboardingService.credentialsProvided(this.account.id);
    }

    action.subscribe(() => this.activeModal.close());
  }
}
